import React, { useState, useEffect } from 'react';
import FilterBar from '../../../components/FilterBar';
import { useSelector, useDispatch } from 'react-redux';
import {
    Col,
    ConfigProvider,
    DatePicker,
    Row,
    Spin,
    Select,
    Avatar,
} from 'antd';
import { IoArrowBack } from 'react-icons/io5';
import { Link, useNavigate } from 'react-router-dom';
import TableWrapper from '../../../components/Grid';
import filter from '../../../assets/images/filter.png';
import { Button } from '../../../components';
import { Colors } from '../../../config';
import BasicDrawer from '../../../components/Drawer';
import moment from 'moment';
import RequestTimeOffDrawer from './RequestTimeOffDrawer';
import { UserOutlined } from '@ant-design/icons';
import { FaEye } from 'react-icons/fa';
import { ShiftDropOrSwap, ShiftTorAction } from '../../../store/actions';
import dayjs from 'dayjs';
import useColors from '../../../hooks/useColors';
import { statusColors } from '../../../config/colors';
import { FaFilter } from 'react-icons/fa6';
import { useQuery } from 'react-query';
import { getAllUsers } from '../../../config/getApis';

const ManageShift = () => {
    const { colorPrimary } = useColors();

    const { user } = useSelector((state) => state?.AppReducer);
    const isRole = user?.userRole[0];
    const { loader, dropOrSwapData } = useSelector(
        (state) => state?.ShiftDropOrSwapReducer,
    );
    const { data, paginate } = dropOrSwapData;
    console.log('hey', dropOrSwapData);

    const dispatch = useDispatch();

    const [state, setState] = useState({
        search: '',
        page: 1,
        limit: 20,
        filterDrawer: {
            status: [],
            user: '',
            requestedOn: '',
        },
    });

    const [drawerStates, setDrawerStates] = useState({
        filter: false,
        requestTimeOffDrawerOpen: false,
    });

    useEffect(() => {
        dispatch(ShiftDropOrSwap.GetDropOrSwap(state));
    }, []);

    const { data: usersOptions } = useQuery(
        ['users'],
        () => getAllUsers('', '', 'fullName'),
        {
            enabled: drawerStates.filter,
        },
    );

    const navigate = useNavigate();

    const timeOfRequestHandler = () => {
        setDrawerStates({ ...drawerStates, requestTimeOffDrawerOpen: true });
    };

    const debounce = (query, delay) => {
        let timeout;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            return dispatch(
                ShiftDropOrSwap.GetDropOrSwap({
                    search: query,
                    page: 1,
                    limit: state?.limit,
                    filterDrawer: {
                        status: state?.filterDrawer?.status,
                        user: state?.filterDrawer?.user,
                        requestedOn: state?.filterDrawer?.requestedOn,
                    },
                }),
            );
        }, [delay]);
    };

    const handleInputChange = (event) => {
        const query = event?.target.value;
        setState({ ...state, page: 1, search: query });
        debounce(query, 2000);
    };

    const formatStatusQuery = (statusArray) =>
        statusArray.map((status) => `status[]=${status}`).join('&');

    const incidentFilters = () => {
        const { status, user, requestedOn } = state?.filterDrawer;

        if (status?.length || user || requestedOn) {
            const { search, limit } = state;
            const queryParams = {
                search,
                page: 1,
                limit,
            };

            const formattedStatus = formatStatusQuery(status);
            let additionalParams = '';

            if (user) {
                additionalParams += `&user_id=${user}`;
            }
            if (requestedOn) {
                additionalParams += `&requested_on=${requestedOn}`;
            }

            dispatch(
                ShiftDropOrSwap.GetDropOrSwap({
                    ...queryParams,
                    formattedStatus,
                    additionalParams,
                }),
            );
            setState({ ...state, page: 1 });
            setDrawerStates({ ...drawerStates, filter: false });
        }
    };

    const clearFilters = () => {
        const { search, limit } = state;
        setState({
            ...state,
            page: 1,
            filterDrawer: {
                status: [],
                user: '',
                requestedOn: '',
            },
        });
        dispatch(
            ShiftDropOrSwap.GetDropOrSwap({
                search,
                page: 1,
                limit,
                filterDrawer: {
                    status: [],
                    user: '',
                    requestedOn: '',
                },
            }),
        );
        setDrawerStates({ ...drawerStates, filter: false });
    };

    const handlePaginationChange = (page, limit) => {
        const { search, filterDrawer } = state;
        const { status, user, requestedOn } = filterDrawer;

        const formattedStatus = formatStatusQuery(status);
        let additionalParams = '';

        if (user) {
            additionalParams += `&user_id=${user}`;
        }
        if (requestedOn) {
            additionalParams += `&requested_on=${requestedOn}`;
        }

        const payload = {
            search,
            limit,
            page,
            formattedStatus,
            additionalParams,
        };

        setState((prev) => ({
            ...prev,
            page,
            limit,
            filterDrawer: {
                status,
                user,
                requestedOn,
            },
        }));

        dispatch(ShiftDropOrSwap.GetDropOrSwap(payload));
    };

    const TorColumns = [
        {
            title: 'Name',
            dataIndex: 'user',
            key: '',
            align: 'left',
            render: (text, record) => (
                <Row justify={'center'} className="flex items-center">
                    <Col span={24} className="flex justify-start items-center">
                        {record?.user?.profileImg ? (
                            <Avatar
                                className="mr-5"
                                size={40}
                                src={record?.user?.profileImg[0]?.url}
                            />
                        ) : (
                            <Avatar
                                className="mr-5"
                                size={40}
                                icon={<UserOutlined />}
                            />
                        )}
                        <span>
                            <Link
                                to={`/workforce-management/DSR/detail/${record?.id}`}
                                className=""
                            >
                                {record?.shift?.shiftUser[0]?.user?.firstName +
                                    ' ' +
                                    record?.shift?.shiftUser[0]?.user?.lastName}
                            </Link>
                        </span>
                    </Col>
                </Row>
            ),
        },

        {
            title: 'Status',
            dataIndex: 'status',
            key: '',
            align: 'left',
            render: (text, record) => (
                <Row justify="center">
                    <Col span={24}>
                        <span className={statusColors[record.status]}>
                            {record.status}
                        </span>
                    </Col>
                </Row>
            ),
        },
        {
            title: 'Shift',
            dataIndex: 'startDate',
            key: '',
            align: 'left',
            render: (text, record) => (
                <Row justify={'center'}>
                    <Col span={24}>
                        <span>
                            {`Security Guard at ${record?.shift?.location?.name || 'Unknown Location'}`}
                        </span>
                    </Col>
                </Row>
            ),
        },
        {
            title: 'Requested On',
            dataIndex: 'requestedOn',
            key: '',
            align: 'left',
            render: (text, record) => (
                <Row justify={'center'}>
                    <Col span={24}>
                        <span>
                            {record?.createdAt
                                ? dayjs(record?.createdAt).format(
                                    'ddd MMM DD, YYYY - HH:mm',
                                )
                                : '-'}
                        </span>
                    </Col>
                </Row>
            ),
        },
    ];

    return (
        <>
            {/* ── Top bar: Back (left) | Search + Button (right) ── */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '12px 0', flexWrap: 'wrap' }}>
                {/* Back */}
                <div
                    className="flex items-center gap-2 cursor-pointer"
                    onClick={() => navigate('/workforce-management')}
                    style={{ color: '#555', userSelect: 'none', fontSize: 14 }}
                >
                    <IoArrowBack size={18} />
                    <span>Back</span>
                </div>

                {/* Search + Button */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                    <input
                        placeholder="Search"
                        value={state?.search}
                        onChange={handleInputChange}
                        style={{
                            background: '#eff2f5',
                            border: '1px solid #eff2f5',
                            borderRadius: 6,
                            padding: '8px 14px',
                            fontSize: 14,
                            outline: 'none',
                            width: 220,
                            height: 40,
                        }}
                    />
                    {(isRole === 'admin' || isRole === 'manager') && (
                        <Button.Basic
                            className="text-white outline-none border-none cursor-pointer px-4 whitespace-nowrap"
                            style={{ height: 40, background: colorPrimary, color: Colors.White }}
                            text="Request Swap/Drop"
                            onClick={timeOfRequestHandler}
                        />
                    )}
                </div>
            </div>


            <Row
                gutter={[8, 32]}
                className="w-fit sm:w-fit lg:w-fit xl:w-full bg-white p-4 rounded-lg "
            >
                <Col lg={24}>
                    <Row className="w-full">
                        <Col lg={24}>
                            <TableWrapper
                                tableStyle={{
                                    borderRadius: '40px',
                                    width: '100%',
                                }}
                                headerbg={'red'}
                                tableColumns={TorColumns}
                                title={() => (
                                    <div className="flex items-center justify-between">
                                        <span className="text-lg font-bold">
                                            WorkForce Management - Manage Swap/Drop Shifts
                                        </span>

                                        <FaFilter
                                            size={35}
                                            color="white"
                                            style={{ background: colorPrimary }}
                                            className="cursor-pointer p-2 rounded-md"
                                            onClick={() =>
                                                setDrawerStates((prev) => ({
                                                    ...prev,
                                                    filter: true,
                                                }))
                                            }
                                        />
                                    </div>
                                )}
                                tableData={data}
                                total={paginate?.total}
                                pageSize={state.limit}
                                currentPage={state.page}
                                handlePaginationChange={handlePaginationChange}
                                loading={loader && <Spin />}
                                rowClassName={'row-antd'}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>

            <BasicDrawer
                openDrawer={drawerStates?.filter}
                onClose={() =>
                    setDrawerStates({ ...drawerStates, filter: false })
                }
                width={300}
                title={'Filters'}
                children={
                    <>
                        <Row
                            gutter={[16, 32]}
                            className="flex justify-between"
                        >
                            <Col span={24}>
                                <label className="font-normal text-[#4E5D78]">
                                    Status
                                </label>
                                <ConfigProvider
                                    theme={{
                                        components: {
                                            Select: {
                                                optionSelectedBg: colorPrimary,
                                                optionActiveBg:
                                                    Colors.LightGray,
                                                optionSelectedColor:
                                                    Colors.White,
                                                selectorBg: Colors.LightGray
                                            },
                                        },
                                    }}
                                >
                                    <Select
                                        allowClear={true}
                                        className="w-full h-9 outline-none rounded"
                                        options={[
                                            {
                                                label: 'pending',
                                                value: 'pending',
                                            },
                                            {
                                                label: 'accepted',
                                                value: 'accepted',
                                            },
                                            {
                                                label: 'denied',
                                                value: 'denied',
                                            },
                                            {
                                                label: 'approved',
                                                value: 'approved',
                                            },
                                            {
                                                label: 'cancelled',
                                                value: 'cancelled',
                                            },
                                        ]}
                                        value={
                                            state?.filterDrawer?.status || []
                                        } // Ensure the value is always an array
                                        mode="multiple" // Enable multi-select
                                        onChange={(value) => {
                                            setState({
                                                ...state,
                                                filterDrawer: {
                                                    ...state?.filterDrawer,
                                                    status: value || [], // Ensure `status` is always an array
                                                },
                                            });
                                        }}
                                    />
                                </ConfigProvider>
                            </Col>

                            <Col span={24}>
                                <label className="font-normal text-[#4E5D78]">
                                    User
                                </label>
                                <ConfigProvider
                                    theme={{
                                        components: {
                                            Select: {
                                                optionSelectedBg: colorPrimary,
                                                optionActiveBg:
                                                    Colors.LightGray,
                                                optionSelectedColor:
                                                    Colors.White,
                                                selectorBg: Colors.LightGray,
                                            },
                                        },
                                    }}
                                >
                                    <Select
                                        allowClear={true}
                                        className="w-full h-9 outline-none rounded"
                                        value={state?.filterDrawer?.user}
                                        onChange={(value) => {
                                            setState({
                                                ...state,
                                                filterDrawer: {
                                                    ...state?.filterDrawer,
                                                    user: value || '',
                                                },
                                            });
                                        }}
                                        options={usersOptions ? usersOptions : []}
                                        showSearch={true}
                                        filterOption={(input, option) =>
                                            (option?.label ?? '')
                                                .toLowerCase()
                                                .includes(
                                                    input.toLowerCase(),
                                                )
                                        }
                                    />
                                </ConfigProvider>
                            </Col>

                            <Col span={24}>
                                <label className="font-normal text-[#4E5D78]">
                                    Requested On
                                </label>
                                <ConfigProvider
                                    theme={{
                                        components: {
                                            DatePicker: {
                                                cellActiveWithRangeBg:
                                                    colorPrimary,
                                                cellHoverBg:
                                                    Colors.LightGray,
                                            },
                                        },
                                    }}
                                >
                                    <DatePicker
                                        allowClear={true}
                                        className="w-full h-9 outline-none rounded"
                                        value={
                                            state?.filterDrawer?.requestedOn
                                                ? dayjs(state?.filterDrawer?.requestedOn)
                                                : null
                                        }
                                        onChange={(date, dateString) => {
                                            setState({
                                                ...state,
                                                filterDrawer: {
                                                    ...state?.filterDrawer,
                                                    requestedOn: dateString || '',
                                                },
                                            });
                                        }}
                                        format="YYYY-MM-DD"
                                    />
                                </ConfigProvider>
                            </Col>

                            <Row
                                className="w-full flex justify-between gap-4 px-2 self-end"
                                align={'middle'}
                            >
                                <Col span={11}>
                                    <Button.Basic
                                        onClick={incidentFilters}
                                        text={'Search'}
                                        className={
                                            'w-full rounded text-white bg-black'
                                        }
                                        size={'large'}
                                    />
                                </Col>
                                <Col span={11}>
                                    <Button.Basic
                                        onClick={clearFilters}
                                        className="w-full rounded bg-[#FF494C] text-white"
                                        text={'Clear'}
                                        size={'large'}
                                    />
                                </Col>
                            </Row>
                        </Row>
                    </>
                }
            />

            <RequestTimeOffDrawer
                drawerStates={drawerStates}
                setDrawerStates={setDrawerStates}
                timeOffRequest={state}
                setTimeOffRequest={setState}
            />
        </>
    );
};

export default ManageShift;
